import React from 'react';
import BlockWrapper from '@/components/BlockWrapper';
import Hero from '@/components/Hero';
import { getAllPagesWithSlug, getMetadata, getPage } from '@/lib/graphcms';
import { Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { arrayOf, shape } from 'prop-types';

const Page = ({ page: { blocks = [], hero = null } }) => {
  const router = useRouter();

  const isGuide = router.asPath.includes('moving-to');
  const components = isGuide
    ? {
        p: ({ ...props }) => (
          <Typography
            sx={{ '&:not(:last-of-type)': { mb: 1 }, color: theme => theme.palette.text.main }}
            variant="body1"
            {...props}
          />
        ),
        li: props => (
          <Typography variant="body1" component="li" sx={{ color: theme => theme.palette.text.main }} {...props} />
        ),
      }
    : null;

  return (
    <>
      {hero && <Hero {...hero} />}
      {blocks?.map(({ id, ...rest }) => (
        <BlockWrapper key={id} {...rest} components={components} />
      ))}
    </>
  );
};

Page.propTypes = {
  page: shape({
    blocks: arrayOf(shape({}).isRequired).isRequired,
    localBusinessSchema: shape({}),
  }).isRequired,
};

export default Page;

/** Below are NextJS build functions. Please test the build command if you touch these. */

// const randomRange = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

export async function getStaticProps({ params, preview = false }) {
  /**
   * Next does not let us pass any data other than the slug into the params
   * field here so we are forced to make the initial call to "getPage()",
   * see if it returns data successfully, and then make another call to getCityPage when that
   * fails.
   */

  const promisePage = getPage(params.slug.join('/'), preview);
  const page = await promisePage;
  const metadata = await getMetadata(preview);

  return {
    props: {
      page,
      metadata,
    },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  const pages = await getAllPagesWithSlug();
  const slugs = [];
  pages.forEach(({ slug }) => slugs.push(slug.split('/')));
  return {
    paths: slugs.map(slug => ({
      params: { slug },
    })),
    fallback: false,
  };
}
